import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";

function useEditProfile() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const updateProfile = async (params = {}) => {
        setLoading(true);
        setError(null);

        const { id, field, fieldValue } = params;

        if (!id || !field || (!fieldValue && field !== "city")) {
            const errorMessage = "Missing required parameters";
            setError(errorMessage);
            setLoading(false);
            return { error: errorMessage };
        }

        let newParams = {
            id,
            alan: field,
        };

        if (field === "ad") {
            const nameAndSurname = fieldValue.split(" ");
            const name = nameAndSurname
                .slice(0, nameAndSurname.length - 1)
                .join(" ")
                .trim();
            const surname = nameAndSurname.length > 1 ? nameAndSurname[nameAndSurname.length - 1].trim() : "";
            newParams.ad = name;
            newParams.soyad = surname;
        } else {
            newParams.alan_deger = fieldValue || "";
        }

        try {
            if (field === "site") {
                const response = await post({
                    fn: "editLinkedinUserInfo",
                    profileId: id,
                    newLinkedInPath: fieldValue,
                });
                return { data: response.data };
            } else {
                const response = await post({ fn: "profilKaydet", ...newParams });
                return { data: response.data };
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.text || error?.message || "An unexpected error occurred";
            setError(errorMessage);
            toast.error(errorMessage);
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { updateProfile, loading, error };
}

export default useEditProfile;
